import React, { useState } from 'react';
import { useMutation } from '@apollo/client';
import { manualStoreInvoiceChargeMutation } from '../../graphql/mutations';
import { Alert, Button, FormGroup, FormText, Input, Label } from 'reactstrap';

export function ManualPartnerCharge() {
  const [invoiceId, setInvoiceId] = useState('');
  const [manualStoreInvoiceCharge, { loading, data, error }] = useMutation(
    manualStoreInvoiceChargeMutation,
  );
  const chargeResult = data && data.manualStoreInvoiceCharge;

  const onInvoiceIdInput = (e: any) => {
    setInvoiceId(
      e.target.value
        .replace(
          'https://pickpack2019.billomat.net/app/invoices/show/entityId/',
          '',
        )
        .replace('https://pickpack2019.billomat.net/app/beta/invoices/', ''),
    );
  };

  const onInvoiceChargeSubmit = async () => {
    await manualStoreInvoiceCharge({
      variables: {
        invoice_id: invoiceId,
      },
    });
  };

  console.log({ error, chargeResult, data });

  return (
    <>
      <h5>Manual Partner Invoice Charge</h5>
      <FormGroup>
        <Label>Invoice Id</Label>
        <Input
          type="text"
          id="exampleEmail"
          placeholder="12345 or https://pickpack2019.billomat.net/app/beta/invoices/XXX"
          value={invoiceId}
          disabled={loading}
          onChange={onInvoiceIdInput}
        />
      </FormGroup>
      <FormText color="muted">
        Billomat Invoice has to be created by the AF or automatcially. Invoice
        status has to be either OPEN (completed) or PAID. The default payment
        method of the associated store will be used. After a successfull
        payment, the invoice status will be set to PAID. The amount is parsed
        from the invoice note. The payment direction of the invoice has to be
        PARTNER_OWES_US.
      </FormText>
      <br />

      {error &&
        error.graphQLErrors &&
        error.graphQLErrors.map((errorMessage) => (
          <Alert color="danger">Error: {errorMessage.message}</Alert>
        ))}
      {chargeResult && (
        <div>
          <h5>Charge Result:</h5>
          <dl className="row">
            <dt className="col-sm-3">Transaction id</dt>
            <dd className="col-sm-9">{chargeResult.transaction_id}</dd>
          </dl>
          <dl className="row">
            <dt className="col-sm-3">Charge id</dt>
            <dd className="col-sm-9">{chargeResult.charge_id}</dd>
          </dl>
          <dl className="row">
            <dt className="col-sm-3">Charge result</dt>
            <dd className="col-sm-9">{chargeResult.charge_result}</dd>
          </dl>
          <dl className="row">
            <dt className="col-sm-3">Partner has payment method</dt>
            <dd className="col-sm-9">
              {chargeResult.partner_has_payment_method ? 'true' : 'false'}
            </dd>
          </dl>
          <dl className="row">
            <dt className="col-sm-3">Link to transaction</dt>
            <dd className="col-sm-9">
              {chargeResult.link_to_transaction && (
                <a href={chargeResult.link_to_transaction}>
                  Stripe transaction
                </a>
              )}
            </dd>
          </dl>
        </div>
      )}

      <Button disabled={loading} onClick={onInvoiceChargeSubmit}>
        {loading ? 'loading...' : 'Charge Partner manually'}
      </Button>
    </>
  );
}
